export const NODE_TYPES = [
  { value: 'operation', label: 'Operación' },
  { value: 'value', label: 'Valor' },
];

export const OPERATION_TYPES = [
  { value: 'add', label: 'Suma' },
  { value: 'sub', label: 'Resta' },
  { value: 'mul', label: 'Multiplicación' },
  { value: 'div', label: 'División' },
  { value: 'pct', label: 'Porcentaje' },
  { value: 'max', label: 'Máximo' },
  { value: 'min', label: 'Mínimo' },
];

export const VALUE_TYPES = [
  { value: 'insured_value', label: 'Valor asegurado' },
  { value: 'rate', label: 'Tasa' },
  { value: 'vat', label: 'IVA' },
  { value: 'fixed', label: 'Valor fijo' },
];

/** Mínimo o exacto de hijos por operation_type */
export const CHILDREN_RULES = {
  add: { min: 2 },
  sub: { min: 2 },
  mul: { min: 2 },
  div: { exact: 2 },
  pct: { exact: 1 },
  max: { min: 2 },
  min: { min: 2 },
};

export const DEFAULT_ROOT_EXPRESSION = {
  nodeType: 'operation',
  operationType: 'mul',
  order: 1,
  children: [
    { nodeType: 'value', valueType: 'insured_value', order: 1, valueName: 'Valor asegurado' },
    { nodeType: 'value', valueType: 'rate', order: 2, valueName: 'Tasa' },
  ],
};
